<template>
  <div class="main-wrapper">
    <table>
      <tr v-for="row in rows" :key="row.id">
        <td width="5%">
          <input
            type="checkbox"
            v-model="row.checkbox"
            @click="onClickCheckBox(row.id)"
            :disabled="!row.checkbox"
          />
        </td>
        <td>
          <p
            :class="row.bold != null && row.bold ? 'necessary-bold' : 'just-p'"
          >
            {{ row.CAPTION }}
          </p>
        </td>
        <td width="310px" class="last-column">
          <input
            v-show="row.FILE == null"
            type="file"
            id="file"
            ref="file"
            accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
            v-on:change="fileUpload(row.id)"
            @click="onClickFileButton(row.id)"
            :disabled="row.DISABLED != null && row.DISABLED"
          />
          <div
            class="file-name-icon"
            v-if="row.FILE != null"
            @click="onClickBan(row.id)"
          >
            <div class="icons">
              <i class="fa fa-trash"></i>
            </div>
            <p class="file-name">{{ row.FILE.name }}</p>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableFiles",
  props: {
    pageInfo: {},
    rowsParent: Array,
  },
  data: () => ({
    rows: [],
  }),
  methods: {
    onClickBan(id) {
      if (this.rows[id].DISABLED == null || !this.rows[id].DISABLED) {
        this.rows[id].FILE = null;
        this.rows[id].checkbox = false;
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
        this.$emit("updateFiles", this.rows, false);
      }
    },
    onClickFileButton(id) {
      this.rows[id].FILE = null;
      this.$emit("updateFiles", this.rows, false);
    },
    fileUpload(id) {
      if (this.checkFiles(id, this.$refs.file[id].files[0])) {
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
      } else this.rows[id].FILE = this.$refs.file[id].files[0];
      this.rows[id].checkbox = this.rows[id].FILE != null;
      this.$emit("updateFiles", this.rows, false);
    },
    onClickCheckBox(id) {
      this.rows[id].FILE = null;
      let input = this.$refs.file[id];
      input.type = "text";
      input.type = "file";
      this.$emit("updateFiles", this.rows, false);
    },
    checkFiles(id, file) {
      let a = false;
      this.rows.forEach((item) => {
        if (item.FILE != null) {
          a = a || item.FILE.name == file.name;
        }
      });
      if (a) this.$alert("Файл " + file.name + " уже загружен");
      else if (file.size > 31457280) {
        this.$alert(
          "Размер файла " + file.name + " превышает допустимый размер (30 МБ)"
        );
        a = true;
      }
      return a;
    },
  },
  updated() {
    this.rowsParent.forEach((item) => {
      if (item.FILE == null && this.$refs.file[item.id].files[0] != null) {
        this.rows[item.id].FILE = null;
        this.rows[item.id].checkbox = false;
        let input = this.$refs.file[item.id];
        input.type = "text";
        input.type = "file";
        this.$emit("updateFiles", this.rows, false);
      }
    });
  },
  mounted() {
    this.rows = [];
    this.rows = this.rowsParent.slice();
    this.$emit("updateFiles", this.rows, true);
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
.last-column {
  border: 1px solid black;
}
tr {
  border: 1px solid black;
}
td {
  padding: 0px 10px;
}
.icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
</style>